import MUIRichTextEditor from 'mui-rte'
import React from 'react'

export default function Description({ description }) {
  return (
    <MUIRichTextEditor defaultValue={description} readOnly controls={[]}/>
  )
}